import React, { useState, useEffect } from 'react';
import './CTA.css';
import WaitlistForm from '../../common/WaitlistForm/WaitlistForm';

function CTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [showWaitlist, setShowWaitlist] = useState(false);
  
  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="cta-section">
      <div className={`cta-content ${isVisible ? 'visible' : ''}`}>
        <div className="cta-text">
          <h1>
              <span className="block">Get your brand mentioned</span> 
              <span className="block">in AI Search</span>
          </h1>
          <p className="subtitle">Drive qualified traffic as millions of consumers turn to AI for purchase decisions.</p>
          <div className="cta-container">
            {/* Comment out the original waitlist button */}
            {/* <button 
              onClick={() => setShowWaitlist(true)} 
              className="cta-button"
            >
              Request Early Access
            </button> */}

            {/* Add new Calendly button */}
            <a 
              href="https://calendly.com/ishgun-tryxlr8/30min"
              target="_blank"
              rel="noopener noreferrer"
              className="cta-button"
            >
              Book a Demo
            </a>
          </div>
        </div>
      </div>

      {/* Keep the waitlist form component for future reference */}
      {showWaitlist && (
        <WaitlistForm onClose={() => setShowWaitlist(false)} />
      )}
    </section>
  );
}

export default CTA; 